/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetFilterOptions$Params {

/**
 * name of the model
 */
  model: string;

/**
 * the settlement flag. if true the service will return settled transactions otherwise unsettled
 */
  settled: boolean;

/**
 * the column name
 */
  name: string;

/**
 * customer GUID from svgzapi-core
 */
  customerGUID: string;

/**
 * the search string
 */
  search?: string;

/**
 * limitation of result
 */
  limit?: number;

/**
 * a list of providers
 */
  providers?: Array<string>;
}

export function getFilterOptions(http: HttpClient, rootUrl: string, params: GetFilterOptions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, getFilterOptions.PATH, 'get');
  if (params) {
    rb.path('model', params.model, {});
    rb.query('settled', params.settled, {});
    rb.path('name', params.name, {});
    rb.query('customerGUID', params.customerGUID, {});
    rb.query('search', params.search, {});
    rb.query('limit', params.limit, {});
    rb.query('providers', params.providers, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<string>>;
    })
  );
}

getFilterOptions.PATH = '/filter/{model}/{name}';
